import { AxiosResponse } from "axios";
import FileSaver from "file-saver";
import { convertUtcToTzIsoStringWithFormat } from "../../util/timezoneConversion";


export const formatPositiveNumber = (num: number) => {
  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "k" },
    { value: 1e6, symbol: "M" },
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup
    .slice()
    .reverse()
    .find(function (item) {
      return num >= item.value;
    });
  return item
    ? (num / item.value).toFixed(1).replace(rx, "$1") + item.symbol
    : "0";
};

export const formatNegativeNumber = (num: number) => {
  const lookup = [
    { value: -1, symbol: "" },
    { value: -1e3, symbol: "k" },
    { value: -1e6, symbol: "M" },
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup
    .slice()
    .reverse()
    .find(function (item) {
      return num <= item.value;
    });
  return item
    ? (num / item.value).toFixed(1).replace(rx, "$1") + item.symbol
    : "0";
};

export const saveFileFromResponse = (
  response: AxiosResponse,
  fileName?: string
) => {
  const filename =
    fileName ||
    response?.headers?.["content-disposition"]?.split("filename=")[1] ||
    "Download";
  const blob = new Blob([response.data], {
    type: response.headers["content-type"],
  });
  FileSaver.saveAs(blob, filename);
};

interface changeNumberOptions {
  decimalPointLength?: number;
  numberLength?: number;
  maxNumber?: number;
  minNumber?: number;
}

export const onChangeTextNumber = (
  value: string,
  options?: changeNumberOptions
) => {
  if (
    options?.decimalPointLength === 0 &&
    (value.includes(".") || value.includes(","))
  ) {
    return;
  }

  if (value.includes(".") && (value.match(/\.|\,/g) || []).length > 1) {
    return;
  }

  if (
    options?.decimalPointLength &&
    value.split(".").length === 2 &&
    value.split(".")?.[1].length > options.decimalPointLength
  ) {
    return;
  }

  if (
    options?.numberLength &&
    value.includes(".") &&
    value.split(".").length === 2 &&
    value.split(".")?.[0].length > options.numberLength
  ) {
    return;
  }

  if (
    options?.numberLength &&
    !value.includes(".") &&
    value.length > options.numberLength
  ) {
    return;
  }

  if (options?.maxNumber && parseFloat(value) > options.maxNumber) {
    return;
  }

  if (options?.minNumber && parseFloat(value) < options.minNumber) {
    return;
  }

  if (value.includes(",")) {
    return value.replace(",", ".");
  }

  return value;
};

export const Parser = {
  distance: (val: number | string | undefined | null) => {
    if (val === undefined || val === null) return;

    const dist = typeof val === "number" ? val : parseFloat(val);
    return dist.toFixed(0);
  },
  price: (val: number | string | undefined | null) => {
    if (val === undefined || val === null) return;

    const price = typeof val === "number" ? val : parseFloat(val);
    return price.toFixed(2);
  },
  enginePowerCode2Description: (code: string) => {
    /**
            D: Termic Diesel
            E: Electric
            G: Termic LPG
            B: Termic Gasoline
            HB: Hybrid Gasoline
            HD: Hybrid Diesel
         */
    if (code === "D") {
      return "Termic Diesel";
    } else if (code === "E") {
      return "Electric";
    } else if (code === "G") {
      return "Termic LPG";
    } else if (code === "B") {
      return "Termic Gasoline";
    } else if (code === "HB") {
      return "Hybrid Gasoline";
    } else if (code === "HD") {
      return "Hybrid Diesel";
    }

    return null;
  },
};

export const formatedDate = "DD/MM/YYYY HH:mm";

export const formatDateTable = (
  date: string | null | undefined,
  timezoneId: string | null | undefined
) => {
  const tz = timezoneId || "Europe/Rome";
  return (
    <>
      {date ? (
        // <span>{dayjs(date).format(formatedDate)}</span>
        <span>{convertUtcToTzIsoStringWithFormat(date, tz, formatedDate)}</span>
      ) : (
        <span> </span>
      )}
    </>
  );
};
